<template>
  <div class="d-flex align-center">
    <confirmation-dialog
      ref="markAsEvaluatedDialog"
      :title="
        `Complete evaluation for this ${
          isQualification ? 'qualification' : 'course'
        }?`
      "
      @confirm="() => markAsEvaluated(uuid)"
    >
      After confirming, the course will be marked as evaluated and will not be
      shown in the list. You will not be able to evaluate any of the remaining
      assignments after marking the course as evaluated.

      <template v-slot:activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          class="rounded"
          color="primary"
          depressed
          v-on="on"
        >
          Mark as Evaluated
        </v-btn>
      </template>
    </confirmation-dialog>
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/_shared/ConfirmationDialog'

import { USER_COURSE_QA } from '@/utils/constants'

export default {
  name: 'MarkAsEvaluated',

  components: {
    ConfirmationDialog,
  },

  props: {
    uuid: {
      type: String,
      required: true,
    },
    isQualification: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    userId() {
      return this.$route.params.userId
    },
  },

  methods: {
    getQaCompleteionValue(item) {
      const { evaluated_assignments, total_assignments } = item
      return (evaluated_assignments / total_assignments) * 100
    },

    async markAsEvaluated(uuid) {
      const dialog = this.$refs.markAsEvaluatedDialog
      dialog.confirmBtnLoading = true

      const status = {
        status: USER_COURSE_QA.COMPLETED,
      }

      try {
        const data = {
          uuid,
          userId: this.userId,
          data: status,
          qualification: this.isQualification,
        }
        await this.$api.enrollment.markAsEvaluated(data)
        dialog.close()

        if (this.isQualification)
          this.$toast.success('Qualification evaluation complete')
        else this.$toast.success('Course evaluation complete')
        this.$emit('get-courses')
      } catch (e) {
        console.error(e)
        if (e.response?.data.errors?.message)
          this.$toast.error(e.response.data.errors.message)
        else this.$toast.error('There was an issue completing the evaluation')
      } finally {
        dialog.confirmBtnLoading = false
      }
    },
  },
}
</script>

<style></style>
